export default __webpack_public_path__ + "static/media/krzyzowka_2_rozw.242010ee.jpg";